import React, { ReactNode, MouseEvent } from 'react';
import {
  Link as CookbookLink,
  LinkProps as CookbookLinkProps,
} from '@grubhubprod/gh-cookbook-react';
import {
  Link as ReactRouterLink,
  LinkProps as RouterLinkProps,
  useHistory,
} from 'react-router-dom';

interface IInAppLinkProps {
  href: string;
  children: ReactNode | string;
  preNavigationFunction?: () => void;
  target?: string;
}

export type Props = Partial<
  CookbookLinkProps & RouterLinkProps & IInAppLinkProps
>;

export const RouterLink: React.FC<Props> = ({
  href,
  children,
  preNavigationFunction,
  target,
}) => {
  const { push } = useHistory();

  function runFunctionBeforeNavigation(
    event: MouseEvent<HTMLAnchorElement>
  ): void {
    event.preventDefault();

    preNavigationFunction();

    push(href);
  }

  const ReactLink = (props: Props) => {
    const { children, enableVisitedStyle, ...rest } = props;

    return (
      <ReactRouterLink to={href} {...rest}>
        {children}
      </ReactRouterLink>
    );
  };

  return (
    <CookbookLink
      as={(props) => <ReactLink {...props} />}
      href={href}
      {...(target && {
        target,
      })}
      {...(preNavigationFunction && {
        onClick: runFunctionBeforeNavigation,
      })}
    >
      {children}
    </CookbookLink>
  );
};
